import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ItemImageComponent } from "./item-image/item-image.component";
import { ItemImageUploaderComponent } from "./item-image/item-image-uploader/item-image-uploader.component";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { FormsModule } from "@angular/forms";
import { ItemCategoriesImageComponent } from "./item-categories-image/item-categories-image.component";
import { ItemCategoriesSelectComponent } from "./item-categories-image/item-categories-select/item-categories-select.component";
import { MenuSettingComponent } from "./menu-setting/menu-setting.component";
import { ConnectOnlineMenuComponent } from "./connect-online-menu/connect-online-menu.component";
import { RahkaranFormComponent } from "./rahkaran/rahkaran-form/rahkaran-form.component";
import { RahkaranListComponent } from "./rahkaran/rahkaran-list/rahkaran-list.component";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { RahkaranSettingComponent } from "./rahkaran/rahkaran-setting/rahkaran-setting.component";

const components = [
  ItemImageComponent,
  ItemImageUploaderComponent,
  ItemCategoriesImageComponent,
  ItemCategoriesSelectComponent,
  MenuSettingComponent,
  ConnectOnlineMenuComponent,
  RahkaranFormComponent,
  RahkaranListComponent,
  RahkaranSettingComponent
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class PortalModule {}
